<template>
  <div v-if="hasCategories()" class="categories">
    <div class="c-title-wrap mar-top-40">
      <p class="c-title">展现栏目</p>
    </div>
    <div class="business" v-for="(item, index) in bizList" :key="index">
      <div class="business_tit">
        <strong>{{ item.name }}</strong>
      </div>
      <div class="column" v-for="(item1, index1) in item.contentCategorys" :key="index1">
        <div class="column_tit">
          <div class="cloumn_tit_label">栏目{{ index1 + 1 }}</div>
          <!--  :class="[item1.isChecked ? 'tabs' : '']" -->
          <div class="column_tit_value" :class="[item1.checked ? 'tabs' : '']">
            {{ item1.name }}
          </div>
        </div>
        <div class="channels" v-if="item1.contentChannels">
          <div class="channel" v-for="(item2, index2) in item1.contentChannels" :key="index2"
               @click.stop="clickChannelAndUpdateCategoryAndBiz(item2)" :class="[item2.checked ? 'tabs' : '']">
            <p>{{ item2.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryAuditBusinessDetail} from "../../api/questionsLibrary";

export default {
  name: "BusinessQuestion",
  props: ['contentId'],
  data() {
    return {
      articleId: null,  // 文章ID
      app_type: process.env.VUE_APP_TYPE,
      isFirstChooseBizTag: true, // 初始化是否第一次点击业务标签的标识，如果点击过，则置该值为false,在标题提交的时候有用。
      bizList: [],
      contentBusinesses: [], // 关联业务
      contentCategorys: [], // 关联栏目、频道
      contentChannels: [], // 频道
    }
  },
  created() {
    if (this.contentId) {
      this.getBusiness()
    }
  },
  methods: {
    hasCategories() {
      return this.app_type == 'man' || this.user_identity == 3;
    },
    // 查询业务
    getBusiness(id) {
      queryAuditBusinessDetail({
        contentId: this.contentId || id || null,
        tenantId: this.$commonJs.getTenantId()
      }).then(res => {
        // console.log('获取的业务栏目信息')
        // console.log(res)
        if (res) {
          this.bizList = res.data
        }
      })
    },
    // 点击
    clickChannelAndUpdateCategoryAndBiz(val) {
      this.isFirstChooseBizTag = false;
      val.checked = !val.checked;
      this.bizList.map((item, index) => {
        var isBizExisted = false;
        if (item.contentCategorys) {
          item.contentCategorys.map((j, o) => {
            var isCategoryExisted = false;
            if (j.contentChannels) {
              j.contentChannels.map((j, l) => {
                if (j.checked) {
                  isCategoryExisted = true;
                }
              })
              j.checked = isCategoryExisted;
              if (isCategoryExisted) {
                isBizExisted = true;
              }
            } else {
              isBizExisted = j.checked = false;
            }
          })
          item.checked = isBizExisted;
        } else {
          item.checked = false;
        }
      })
    },
    // 保存文章之前，构造业务栏目频道的标签的提交表单数据。
    getBizListData(parentForm) {
      // 用户端 未知 医护 写手角色，没有该字段，所以直接返回了
      if (!this.bizList || !this.bizList.length) {
        return;
      }
      // 先置空原来的值
      this.contentCategorys = [];
      this.contentBusinesses = [];
      this.contentChannels = [];
      // 开始构建用户目前选择的值
      this.bizList.forEach((item) => {
        if (item.contentCategorys && item.contentCategorys.length > 0) {
          item.contentCategorys.forEach(value => {
            // 栏目
            let arr = [];
            if (value.checked) {
             this.contentBusinesses.push({businessId: item.id, name: item.name});
              value.contentChannels && value.contentChannels.forEach(label => {
                // 频道
                if (label.checked) {
                  arr.push({channelId: label.id, channelName: label.name});
                }
              });
              this.contentCategorys.push({categoryId: value.id, categoryName: value.name, contentChannels: arr});
            }
          });
        }
      });
      parentForm.contentCategorys = this.contentCategorys;
      parentForm.contentBusinesses = this.contentBusinesses;
      parentForm.contentChannels = this.contentChannels;
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";

.categories {
  line-height: 30px;
  font-size: 16px;

  .business {
    padding-left: 28px;
    margin-right: 20px;
    margin-bottom: 10px;
    @include singleline-ellipsis;

    .business_tit {
      margin-bottom: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      height: 20px;
      color: rgba(51, 56, 64, 1);
      margin-top: 27px;
    }

    .column {
      margin: 0px 20px 0px 21px;
      position: relative;

      .column_tit {
        margin-bottom: 20px;
        font-size: 14px;
        color: rgba(95, 95, 107, 1);
        text-align: center;
        display: flex;

        .cloumn_tit_label {
          width: 60px;
          text-align: right;
        }

        &:nth-child(1) {
          margin-top: 36px;
        }

        margin-top: 105px;

        .column_tit_value {
          height: 34px;
          padding: 6px 21px;
          margin-left: 10px;
          //border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          line-height: 16px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
        }

        @include singleline-ellipsis;
      }

      .channels {
        display: flex;
        margin-top: 21px;
        padding-left: 70px;
        display: flex;
        flex-wrap: wrap;

        .channel {
          height: 34px;
          padding: 6px 38px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          line-height: 20px;
          // height: 32px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          margin-right: 30px;
          cursor: pointer;
          max-width: 200px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 28px;

          p {
            height: 21px;
            font-size: 14px;
            color: rgba(95, 95, 107, 1);
            line-height: 21px;
            @include singleline-ellipsis;
          }
        }
      }
    }
  }

  .tabs {
    border: 1px solid #0058ee !important;
    border-radius: 4px !important;
    color: #0058ee !important;
    background: url("~@/assets/choose.png") right bottom no-repeat;
    background-size: 18px;

    span {
      color: #0058ee !important;
    }

    .have {
      cursor: pointer;
    }

    .button.el-button.el-button--default {
      padding-top: 10px;
    }
  }
}

</style>
